<template>
  <div>
    <section class="hero">
      <div class="pb-1">
        <div class="container is-max-desktop has-text-centered">
          <h1 class="title is-4 is-size-5-mobile pt-5 px-5">
            {{ currentVideo ? currentVideo.title : '' }}
          </h1>
          <p ref="currentVideoId" class="is-hidden">{{ currentVideo ? currentVideo.id : '' }}</p>
          <p class="is-siez-7">
            <span class="has-text-grey-light">
              <!-- <a :href="'https://www.youtube.com/channel/' + currentVideo.channel.provider_meta.youtube_channel_id" class="has-text-grey-light" rel="noreferrer noopener" target="_blank"> -->
                {{ currentVideo ? currentVideo.channel.title : '' }}
              <!-- </a> -->
            </span>
          </p>
        </div>

        <div class="is-flex is-justify-content-center is-align-content-center mt-5">
          <b-button
            class="mx-1 px-5 has-text-weight-semibold stick-button"
            :label="$t('general.share')"
            type="is-dark"
            @click="shareModal"
            outlined
          />
          <b-button
            class="mx-1 px-5 has-text-weight-semibold stick-button"
            :label="isFavorited ? $t('general.liked') : $t('general.like')"
            :type="isFavorited ? 'is-static' : 'is-black'"
            @click="addVideoFromFavorite(videoId)"
          />
        </div>

      </div>
    </section>

    <div class="columns px-5 mt-5 mx-0">
      <div class="column is-three-fifths is-offset-one-fifth">
        <p class="pt-2 pb-3" style="white-space: pre-line; word-wrap:break-word;">
          <foldable :height="100" async>
            {{ currentVideo ? currentVideo.description : '' }}
            <p align="center"
              class="pt-3 is-size-7 has-text-weight-bold is-uppercase"
              slot="view-more" slot-scope="{ toggle, collapsed }"
              @click="toggle(), moreDescription()"
            >
              <b-icon pack="fas" :icon="collapsed ? 'angle-down' : 'angle-up'"></b-icon>
            </p>
          </foldable>
        </p>
      </div>
    </div>
    <div class="divider div-transparent my-5"></div>
    <div class="section container is-max-widescreen pt-2 mb-6">
      <div class="columns">
        <div class="column is-10 is-offset-1">
          <vue-horizontal class="taghorizontal" :displacement="0.7" snap="none">
            <b-button size="is-small"
              class="mr-3"
              type="is-light"
              tag="router-link"
              :to="{ path: '/tags/' + tag.slug }"
              v-for="tag in currentVideo ? currentVideo.tags : ''"
              @click.native="$parent.openBar = true"
              :key="tag.slug">
              {{ tag.trans || tag.name }}
            </b-button>
          </vue-horizontal>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import VueHorizontal from 'vue-horizontal';
import ShareModal from 'components/ShareModal.vue';
import { getVideoById, addFavoriteVideo, getFavoriteStatus } from '@/api/api';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'player-card',
  components: { VueHorizontal },

  data() {
    return {
      videoId: '',
      isFavorited: false,
    };
  },

  computed: {
    ...mapGetters({
      player: 'player',
      user: 'user',
    }),

    ...mapState({
      user: 'user',
    }),

    currentVideo() {
      if (!this.player.videoId) {
        return null;
      }

      return this.player.queue[this.player.currentPlayIndex];
    },
  },

  created() {
    this.timers = setTimeout(() => {
      this.videoId = this.$refs.currentVideoId.innerText;
      this.fetchData(this.videoId);
    }, 200);
  },

  mounted() {
    this.isFavorited = false;
    this.$gtag.event('click_share', {
      event_category: 'general_click',
      event_label: 'User clicked share button',
      value: 1,
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.fetchData(to.params.id);
    this.isFavorited = false;
    next();
  },

  methods: {
    shareModal() {
      this.$FModal.show({
        component: ShareModal,
        overlayStyles: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
      },
      {
        shareId: this.videoId,
        shareRoute: 'video',
        shareTitle: this.title,
      });
    },
    fetchData(id) {
      getVideoById(id, { headers: { locale: this.$i18n.locale } })
        .then(async (result) => {
          const videoData = result.data.data;

          this.id = videoData.id;
          this.title = videoData.title;
          this.youtubeId = videoData.provider_video_id;
          this.description = videoData.description;
          this.created_at = videoData.created_at;
          this.channel = videoData.channel;

          this.tags = videoData.tags.filter((item) => item.type === null);

          this.instrumentTags = videoData.tags.filter((item) => item.type !== null
              && !item.type.includes('genre')
              && !item.type.includes('composer'));

          this.genreTags = videoData.tags.filter((item) => item.type !== null
              && item.type.includes('genre'));

          if (this.user.loggedIn) {
            this.fetchFavoriteStatus();
          }
        })
        .catch((err) => {
          console.error(err);

          if (err.request.status === 404) {
            this.$router.push({ name: '404' });
          }
        });
    },

    fetchFavoriteStatus() {
      getFavoriteStatus(this.videoId)
        .then((status) => {
          this.isFavorited = status.data.is_added;
        });
    },
    addVideoFromFavorite(videoId) {
      if (this.$store.state.user.loggedIn) {
        addFavoriteVideo(videoId)
          .then(() => {
            this.isFavorited = true;

            this.$buefy.snackbar.open({
              duration: 2000,
              message: this.$t('performs.likedmsg'),
              type: 'is-dark',
              position: 'is-bottom',
              actionText: null,
            });
          })
          .catch((err) => {
            console.error(err);

            this.$buefy.snackbar.open({
              message: this.$t('msgs.servererror'),
              type: 'is-danger',
              position: 'is-bottom',
              actionText: this.$t('general.reload'),
              onAction: () => {
                window.location.reload();
              },
            });
          });
      } else {
        this.$router.push({ name: 'Signin' });
        this.$parent.setStatePlayerCard(true);
      }

      this.$gtag.event('like_video', {
        event_category: 'video_related',
        event_label: 'User clicked like button',
        value: 1,
      });
    },

    moreDescription() {
      this.$gtag.event('more_description', {
        event_category: 'video_related',
        event_label: 'User clicked read more',
        value: 1,
      });
    },
  },
};
</script>

<style scoped>
.taghorizontal >>> .v-hl-btn svg {
  border-radius: 0;
  margin: 0;
  padding: 8px;
  height: 100%;
  box-shadow: none;
  background: none;
}

.taghorizontal >>> .v-hl-btn-prev {
  background: linear-gradient(to left, #fafafa00 0, #fafafa 66%, #fafafa);
}

.taghorizontal >>> .v-hl-btn-next {
  background: linear-gradient(to right, #fafafa00 0, #fafafa 66%, #fafafa);
}

.taghorizontal >>> .v-hl-btn {
  top: 0;
  bottom: 0;
  transform: translateX(0);
}
</style>
